import React from "react";

const HeaderTopbar = () => {
  return <div className="topbar" style={{ height: "60px" }}></div>;
};

export default HeaderTopbar;
